import { NavigateFunction } from "react-router";
import { RoleType } from "../../../App/enums";
import { Capacitor } from '@capacitor/core';

export const onHashtagClick = (hashtag: string, navigate: NavigateFunction, role: keyof typeof RoleType, orgId: number) => {

    const isNativeApp = Capacitor.isNativePlatform();

    switch (role) {
        case RoleType.USER:
            if (isNativeApp) {
                navigate(`/hashtag?keyword=${hashtag}`)
            } else {
                window.open(`/hashtag?keyword=${hashtag}`, '_blank')
            }
            break;
        case RoleType.ORGANIZATION:
            if (isNativeApp) {
                navigate(`/${orgId}/hashtag?keyword=${hashtag}`)
            } else {
                window.open(`/${orgId}/hashtag?keyword=${hashtag}`, '_blank')
            }
            break;
        default:
            break;
    }

}